module.exports = __webpack_public_path__ + "media/images/favicon/primary/apple-icon-57x57-e502ffd776297bf1691584bc2ea83ee2.png";